// Backend calls for the dictionary's management tools (bulk verify, delete with
// dependency check). Kept apart from WordBrowserPanel so the panel stays about
// layout and state.

import axios from 'axios';

const jsonHeaders = {
   withCredentials: true,
   headers: { 'Content-Type': 'application/json' },
};

// Every row that deleting these words would remove, one list for all of them.
export function getWordDependencies(wordIds) {
   return axios.get('/api/words/dependencies', { params: { ids: wordIds.join(',') }, withCredentials: true });
}

// dryRun = true runs the same validation and removes nothing.
export function deleteWordDependencies(keys, dryRun) {
   return axios.post('/api/words/dependencies/delete', JSON.stringify({ keys: keys, dryRun: !!dryRun }), jsonHeaders);
}

export function bulkVerifyWords(wordIds, verified) {
   return axios.post('/api/words/bulk-verify', JSON.stringify({ ids: wordIds, verified: !!verified }), jsonHeaders);
}
